// Bugfix 27 (#1397): het gedrag van de vakantie- en overurenpagina's
// (Vakantie & overuren beheren, Vakantieaanvragen, Vakantieplanning):
//   - de dialoog Nieuwe registratie openen, eventueel al met Vakantie of
//     Overuren en een medewerker gekozen;
//   - een dialoog openen of sluiten (aanvraag bekijken, corrigeren);
//   - filters versturen zodra ze veranderen, en de zoekbalk na even typen;
//   - de medewerkerslijst in een formulier filteren op wat er getypt wordt;
//   - een open actiemenu (•••) sluiten bij een klik ernaast.
// Bugfix 32 (#1508): de medewerkerkeuze in de filterbalk doorzoeken en
// sluiten bij een klik ernaast, en het exportvenster sluiten na Export maken.
import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    this.sluitMenus = (event) => {
      this.element.querySelectorAll("details.vo-menu[open], details.vo-multi[open]").forEach((menu) => {
        if (!menu.contains(event.target)) menu.removeAttribute("open")
      })
    }
    document.addEventListener("click", this.sluitMenus)

    // Een actiemenu in een tabel die horizontaal scrolt, zou door die tabel
    // worden afgesneden. Open ligt het daarom vast in het venster, onder (of
    // als daar geen ruimte is boven) de knop.
    this.plaatsMenu = (event) => {
      const menu = event.target
      if (!menu.matches?.("details.vo-menu") || !menu.open) return

      const lijst = menu.querySelector(".vo-menu-lijst")
      const knop = menu.querySelector("summary").getBoundingClientRect()
      lijst.style.position = "fixed"
      lijst.style.right = "auto"
      const breedte = lijst.offsetWidth
      const hoogte = lijst.offsetHeight
      const onder = knop.bottom + 6 + hoogte <= window.innerHeight
      lijst.style.top = `${onder ? knop.bottom + 6 : Math.max(8, knop.top - 6 - hoogte)}px`
      lijst.style.left = `${Math.max(8, Math.min(knop.right - breedte, window.innerWidth - breedte - 8))}px`
    }
    this.element.addEventListener("toggle", this.plaatsMenu, true)

    // #1866: het werkvlak (main) scrolt zelf, niet het venster. Met capture
    // horen we ook dat scrollen (en dat van de tabel); het open menu schuift
    // dan mee met zijn knop, en gaat dicht als de knop uit beeld is.
    this.volgBijScrollen = () => {
      this.element.querySelectorAll("details.vo-menu[open]").forEach((menu) => {
        const knop = menu.querySelector("summary").getBoundingClientRect()
        if (knop.bottom < 0 || knop.top > window.innerHeight) menu.removeAttribute("open")
        else this.plaatsMenu({ target: menu })
      })
    }
    document.addEventListener("scroll", this.volgBijScrollen, { passive: true, capture: true })
  }

  disconnect() {
    document.removeEventListener("click", this.sluitMenus)
    this.element.removeEventListener("toggle", this.plaatsMenu, true)
    document.removeEventListener("scroll", this.volgBijScrollen, { capture: true })
    clearTimeout(this.zoekTimer)
  }

  nieuweRegistratie(event) {
    event.preventDefault()
    const dialoog = document.getElementById("vo-nieuwe-registratie")
    if (!dialoog) return

    const { soort, medewerker } = event.params
    if (soort) {
      const keuze = dialoog.querySelector(`input[name="vo-soort"][value="${soort}"]`)
      if (keuze) keuze.checked = true
    }
    if (medewerker) {
      dialoog.querySelectorAll("select[data-medewerker-select]").forEach((select) => {
        select.value = String(medewerker)
      })
    }
    this.element.querySelectorAll("details.vo-menu[open]").forEach((menu) => menu.removeAttribute("open"))
    dialoog.showModal()
  }

  open(event) {
    event.preventDefault()
    const dialoog = document.getElementById(event.params.dialoog)
    this.element.querySelectorAll("details.vo-menu[open]").forEach((menu) => menu.removeAttribute("open"))
    if (dialoog) dialoog.showModal()
  }

  sluit(event) {
    event.preventDefault()
    event.target.closest("dialog")?.close()
  }

  // Klik op de donkere achtergrond van een dialoog sluit hem
  achtergrond(event) {
    if (event.target === event.currentTarget) event.currentTarget.close()
  }

  filter(event) {
    event.target.form?.requestSubmit()
  }

  zoek(event) {
    clearTimeout(this.zoekTimer)
    const form = event.target.form
    this.zoekTimer = setTimeout(() => form?.requestSubmit(), 450)
  }

  zoekMedewerker(event) {
    const veld = event.target.closest("[data-medewerker-keuze]")
    const select = veld?.querySelector("select[data-medewerker-select]")
    if (!select) return

    const term = event.target.value.trim().toLowerCase()
    let eerste = null
    Array.from(select.options).forEach((optie) => {
      const past = !term || optie.text.toLowerCase().includes(term)
      optie.hidden = !past
      if (past && !eerste) eerste = optie
    })
    if (eerste && select.selectedOptions[0]?.hidden) select.value = eerste.value
  }

  // Bugfix 32 (#1508): de lijst met medewerkers in de filterbalk doorzoeken
  zoekInLijst(event) {
    const lijst = event.target.closest(".vo-multi-lijst")
    const term = event.target.value.trim().toLowerCase()
    lijst?.querySelectorAll("[data-zoektekst]").forEach((optie) => {
      optie.hidden = term !== "" && !optie.dataset.zoektekst.includes(term)
    })
  }

  // Het bestand komt als download; het venster mag dan dicht
  exportGemaakt(event) {
    const dialoog = event.target.closest("dialog")
    setTimeout(() => dialoog?.close(), 300)
  }
}
